const prefix = 'Rainmakers/Dashboard/';

export const ADMIN_LOAD_STARTED = `${prefix}ADMIN_LOAD_STARTED`;
export const ADMIN_LOAD_DONE = `${prefix}ADMIN_LOAD_DONE`;
